import {
    AuditOutlined,
    BarChartOutlined,
    CheckCircleFilled, CheckOutlined, ClockCircleFilled,
    CloseCircleFilled, CloseOutlined, CrownFilled,
    StarFilled,
    TeamOutlined,
    TrophyFilled,
    FileDoneOutlined
} from '@ant-design/icons';
import { Button, Col, Popover, Row, Space, Table, Tag } from 'antd';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from 'chart.js';
import React from 'react';
import { maChucVu, trangThaiKPI, trangThaiKPITongHop } from '../../constants';
import StatCard from '../utils/StatCard';
import { KPIBadge } from './KPIBadge';
import CongViecPopover from './components/CongViecPopover';
import ViPhamPopover from './components/ViPhamPopover';
import YKienVanPhong from './components/YKienVanPhong';
import { KPIPhongBanPagingResponse } from '../../models/kpi/KPIPhongBan';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
export interface TabKetQuaHoanThanhProps {
    danhsach: KPIPhongBanPagingResponse;
    tongHopKPI?: any;
    menu: any;
    user: any;
    anThongKe?: boolean,
    duyetToanDonViBtn?: boolean,
    traVeBtn?: boolean,
    eventDuyetKPICaNhan?: () => void,
    eventTraLaiTongHopKPI?: () => void,
    setConfirmModal?: (val: any) => void;
    setOpenModalChiTiet: (val: any) => void;
    footerElements?: React.ReactNode;
    showYKienVanPhong?: boolean;
}

const TabKetQuaHoanThanh: React.FC<TabKetQuaHoanThanhProps> = ({
    danhsach,
    tongHopKPI,
    menu,
    user,
    anThongKe,
    duyetToanDonViBtn,
    traVeBtn,
    eventDuyetKPICaNhan,
    eventTraLaiTongHopKPI,
    setConfirmModal,
    setOpenModalChiTiet,
    footerElements,
    showYKienVanPhong
}) => {
    const getTrangThaiKPIStats = (stats: any) => {
        const tags = [];
        if (stats.countKhoiTao > 0) tags.push(<Tag color="processing" key="kt" title="Khởi tạo" style={{ margin: '2px' }}> {stats.countKhoiTao} </Tag>);
        if (stats.countThuHoi > 0) tags.push(<Tag color="warning" key="th" title="Thu hồi" style={{ margin: '2px' }}> {stats.countThuHoi} </Tag>);
        if (stats.countTrinhLDP > 0) tags.push(<Tag color="purple" key="tldp" title="Trình LĐ phòng" style={{ margin: '2px' }}> {stats.countTrinhLDP} </Tag>);
        if (stats.countLDPTuChoi > 0) tags.push(<Tag color="error" key="ldptc" title="LĐ phòng từ chối" style={{ margin: '2px' }}> {stats.countLDPTuChoi} </Tag>);
        if (stats.countTrinhLDPT > 0) tags.push(<Tag color="cyan" key="tldpt" title="Trình LĐ phụ trách" style={{ margin: '2px' }}> {stats.countTrinhLDPT} </Tag>);
        if (stats.countLDPTTuChoi > 0) tags.push(<Tag color="error" key="ldpttc" title="LĐ phụ trách từ chối" style={{ margin: '2px' }}> {stats.countLDPTTuChoi} </Tag>);
        if (stats.countTrinhLDDV > 0) tags.push(<Tag color="gold" key="tlddv" title="Trình LĐ đơn vị" style={{ margin: '2px' }}> {stats.countTrinhLDDV} </Tag>);
        if (stats.countLDDVTuChoi > 0) tags.push(<Tag color="error" key="lddvtc" title="LĐ đơn vị từ chối" style={{ margin: '2px' }}> {stats.countLDDVTuChoi} </Tag>);
        if (stats.countPheDuyet > 0) tags.push(<Tag color="success" key="pd" title="Duyệt" style={{ margin: '2px' }}> {stats.countPheDuyet} </Tag>);
        return tags.length > 0 ? <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', cursor: 'pointer' }}> {tags} </div> : "-";
    }
    return (() => {
        const dt = danhsach?.data || [];
        var nhanViens = danhsach?.nhanViens || [];
        // Tính tổng hợp toàn cơ quan
        const tongSoCanBo = nhanViens.length;
        // Tạo một Set chứa tất cả idNhanVien đã có dữ liệu KPI
        const set_idDaDanhGia = new Set(dt.map(kpi => kpi.idNhanVien));
        const tongSoCanBoDanhGia = nhanViens.filter(nv => set_idDaDanhGia.has(nv.idNhanVien)).length;
        const dsCanBoKhongDanhGia = nhanViens.filter(nv => !set_idDaDanhGia.has(nv.idNhanVien));
        const tongSoCanBoKhongDanhGia = tongSoCanBo - tongSoCanBoDanhGia;
        const tongLoaiACong = dt.filter(item => item.xepLoaiDuKien == 'A+').length;
        const tongLoaiA = dt.filter(item => item.xepLoaiDuKien == 'A').length;
        const tongLoaiB = dt.filter(item => item.xepLoaiDuKien == 'B').length;
        const tongLoaiC = dt.filter(item => item.xepLoaiDuKien == 'C').length;

        const dsLoaiACong = dt.filter(item => item.xepLoaiDuKien == 'A+') || [];
        const dsLoaiA = dt.filter(item => item.xepLoaiDuKien == 'A') || [];
        const dsLoaiB = dt.filter(item => item.xepLoaiDuKien == 'B') || [];
        const dsLoaiC = dt.filter(item => item.xepLoaiDuKien == 'C') || [];

        const tongSoCongViec = dt.reduce((s, x) => s + x.soCongViec, 0);
        const tongTruoc = dt.reduce((s, x) => s + x.truoc, 0);
        const tongDung = dt.reduce((s, x) => s + x.dung, 0);
        const tongTre = dt.reduce((s, x) => s + x.tre, 0);
        const tongLoi = dt.reduce((s, x) => s + x.loi, 0);
        const tongDangThucHien = dt.reduce((s, x) => s + x.dangThucHien, 0);
        const tongHoanThanh = tongTruoc + tongDung;
        const tongKhongHoanThanh = tongTre + tongLoi;

        // Tổng hợp theo phòng/ban
        const phongBanMap: { [key: string]: any } = {};
        dt.forEach((d: any) => {
            if (!phongBanMap[d.idDonVi]) {
                phongBanMap[d.idDonVi] = {
                    tenDonVi: d.tenDonVi,
                    tongSoCanBo: new Set<number>(),
                    thuTuDonVi: d.thuTuDonVi,
                    cvList: []
                };
            }
            phongBanMap[d.idDonVi].tongSoCanBo.add(d.idNhanVien);
            phongBanMap[d.idDonVi].cvList.push(d);
        });

         const phongBanList = Object.entries(phongBanMap).sort(([, a]: any, [, b]: any) =>(a.thuTuDonVi ?? 999999) - (b.thuTuDonVi ?? 999999))
            .map(([key, pbItem]: any) => {
            const cvList = pbItem.cvList;
            const tongCV = cvList.reduce((acc: number, d: any) => acc + (d.soCongViec || 0), 0);

            // Chi tiết tiến độ công việc
            const truoc = cvList.reduce((acc: number, d: any) => acc + (d.truoc || 0), 0);
            const dung = cvList.reduce((acc: number, d: any) => acc + (d.dung || 0), 0);
            const dangThucHien = cvList.reduce((acc: number, d: any) => acc + (d.dangThucHien || 0), 0);
            const tre = cvList.reduce((acc: number, d: any) => acc + (d.tre || 0), 0);
            const loi = cvList.reduce((acc: number, d: any) => acc + (d.loi || 0), 0);
            const khongHoanThanh = tre + loi;

            // Chi tiết xếp loại dự kiến
            const countAPlus = cvList.filter((d: any) => d.xepLoaiDuKien === 'A+').length;
            const countA = cvList.filter((d: any) => d.xepLoaiDuKien === 'A').length;
            const countB = cvList.filter((d: any) => d.xepLoaiDuKien === 'B').length;
            const countC = cvList.filter((d: any) => d.xepLoaiDuKien === 'C').length;

            const dsAPlus = cvList.filter((d: any) => d.xepLoaiDuKien === 'A+') || [];
            const dsA = cvList.filter((d: any) => d.xepLoaiDuKien === 'A') || [];
            const dsB = cvList.filter((d: any) => d.xepLoaiDuKien === 'B') || [];
            const dsC = cvList.filter((d: any) => d.xepLoaiDuKien === 'C') || [];
            // Chi tiết lỗi vi phạm
            const dsLoiViPham: any[] = [];
            const dsTruoc: any[] = [];
            const dsDangThucHien: any[] = [];
            const dsTre: any[] = [];

            cvList.forEach((d: any) => {
                const base = { hoTen: d.hoTen, tenDonVi: d.tenDonVi };

                d.loiViPhams?.forEach((loi: any) => dsLoiViPham.push({ ...loi, ...base }));
                d.dangThucHiens?.forEach((th: any) => dsDangThucHien.push({ ...th, ...base }));
                d.truocs?.forEach((truoc: any) => dsTruoc.push({...truoc, ...base }));
                d.tres?.forEach((tre: any) => dsTre.push({ ...tre, ...base }));
            });

            const totalAssessed = pbItem.tongSoCanBo.size;

            const countKhoiTao = cvList.filter((d: any) => d.trangThai === trangThaiKPI.khoiTao).length;
            const countThuHoi = cvList.filter((d: any) => d.trangThai === trangThaiKPI.thuHoi).length;
            const countTrinhLDP = cvList.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoPhong).length;
            const countLDPTuChoi = cvList.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoPhongTuChoi).length;
            const countTrinhLDPT = cvList.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoPhuTrach).length;
            const countLDPTTuChoi = cvList.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoPhuTrachTuChoi).length;
            const countTrinhLDDV = cvList.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoDonVi).length;
            const countLDDVTuChoi = cvList.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoDonViTuChoi).length;
            const countPheDuyet = cvList.filter((d: any) => d.trangThai === trangThaiKPI.pheDuyet).length;

            return {
                idDonVi: key,
                tenDonVi: pbItem.tenDonVi,
                childrens: cvList,
                tongSoCanBo: totalAssessed,
                tongSoCongViec: tongCV,
                tongTruoc: truoc,
                dsTruoc: dsTruoc,
                tyLeTruoc: tongCV > 0 ? ((truoc / tongCV) * 100).toFixed(0) + '%' : '0%',
                tongDung: dung,
                tyLeDung: tongCV > 0 ? ((dung / tongCV) * 100).toFixed(0) + '%' : '0%',
                tongDangThucHien: dangThucHien,
                dsDangThucHien: dsDangThucHien,
                tyLeDangThucHien: tongCV > 0 ? ((dangThucHien / tongCV) * 100).toFixed(0) + '%' : '0%',
                tongKhongHoanThanh: khongHoanThanh,
                dsTre: dsTre,
                tyLeKhongHoanThanh: tongCV > 0 ? ((khongHoanThanh / tongCV) * 100).toFixed(0) + '%' : '0%',
                dsAPlus: dsAPlus,
                countAPlus: countAPlus,
                tyLeAPlus: totalAssessed > 0 ? ((countAPlus / totalAssessed) * 100).toFixed(0) + '%' : '0%',
                countA: countA,
                dsA: dsA,
                tyLeA: totalAssessed > 0 ? ((countA / totalAssessed) * 100).toFixed(0) + '%' : '0%',
                dsB: dsB,
                countB: countB,
                tyLeB: totalAssessed > 0 ? ((countB / totalAssessed) * 100).toFixed(0) + '%' : '0%',
                dsC: dsC,
                countC: countC,
                tyLeC: totalAssessed > 0 ? ((countC / totalAssessed) * 100).toFixed(0) + '%' : '0%',
                dsLoiViPham: dsLoiViPham,
                countKhoiTao,
                countThuHoi,
                countTrinhLDP,
                countLDPTuChoi,
                countTrinhLDPT,
                countLDPTTuChoi,
                countTrinhLDDV,
                countLDDVTuChoi,
                countPheDuyet
            };
        });
        const tyLeTruoc = tongSoCongViec > 0 ? ((tongTruoc / tongSoCongViec) * 100).toFixed(0) + '%' : '0%';
        const tyLeDung = tongSoCongViec > 0 ? ((tongDung / tongSoCongViec) * 100).toFixed(0) + '%' : '0%';
        const tyLeDangThucHien = tongSoCongViec > 0 ? ((tongDangThucHien / tongSoCongViec) * 100).toFixed(0) + '%' : '0%';
        const tyLeKhongHoanThanh = tongSoCongViec > 0 ? ((tongKhongHoanThanh / tongSoCongViec) * 100).toFixed(0) + '%' : '0%';

        const tyLeLoaiACong = tongSoCanBoDanhGia > 0 ? ((tongLoaiACong / tongSoCanBoDanhGia) * 100).toFixed(0) + '%' : '0%';
        const tyLeLoaiA = tongSoCanBoDanhGia > 0 ? ((tongLoaiA / tongSoCanBoDanhGia) * 100).toFixed(0) + '%' : '0%';
        const tyLeLoaiB = tongSoCanBoDanhGia > 0 ? ((tongLoaiB / tongSoCanBoDanhGia) * 100).toFixed(0) + '%' : '0%';
        const tyLeLoaiC = tongSoCanBoDanhGia > 0 ? ((tongLoaiC / tongSoCanBoDanhGia) * 100).toFixed(0) + '%' : '0%';

        const dsLoiViPhamTongCong: any[] = [];
        const dsTruoc: any[] = [];
        const dsDangThucHien: any[] = [];
        const dsTre: any[] = [];

        dt.forEach((d: any) => {
            const base = { hoTen: d.hoTen, tenDonVi: d.tenDonVi };

            d.loiViPhams?.forEach((loi: any) => dsLoiViPhamTongCong.push({ ...loi, ...base }));
            d.truocs?.forEach((truoc: any) => dsTruoc.push({...truoc, ...base }));
            d.dangThucHiens?.forEach((th: any) => dsDangThucHien.push({ ...th, ...base }));
            d.tres?.forEach((tre: any) => dsTre.push({ ...tre, ...base }));
        });

        const tongCong = {
            tongSoCanBo: tongSoCanBoDanhGia,
            tongSoCongViec: tongSoCongViec,
            tongTruoc: tongTruoc,
            dsTruoc: dsTruoc,
            tyLeTruoc: tyLeTruoc,
            tongDung: tongDung,
            tyLeDung: tyLeDung,
            dsDangThucHien: dsDangThucHien,
            tongDangThucHien: tongDangThucHien,
            tyLeDangThucHien: tongSoCongViec > 0 ? ((tongDangThucHien / tongSoCongViec) * 100).toFixed(0) + '%' : '0%',
            tongKhongHoanThanh: tongKhongHoanThanh,
            dsTre: dsTre,
            tyLeKhongHoanThanh: tyLeKhongHoanThanh,
            tongLoaiACong: tongLoaiACong,
            dsLoaiACong: dsLoaiACong,
            tyLeLoaiACong: tyLeLoaiACong,
            tongLoaiA: tongLoaiA,
            dsLoaiA: dsLoaiA,
            tyLeLoaiA: tyLeLoaiA,
            tongLoaiB: tongLoaiB,
            dsLoaiB: dsLoaiB,
            tyLeLoaiB: tyLeLoaiB,
            tongLoaiC: tongLoaiC,
            dsLoaiC: dsLoaiC,
            tyLeLoaiC: tyLeLoaiC,
            dsLoiViPham: dsLoiViPhamTongCong,

            countKhoiTao: dt.filter((d: any) => d.trangThai === trangThaiKPI.khoiTao).length,
            countThuHoi: dt.filter((d: any) => d.trangThai === trangThaiKPI.thuHoi).length,
            countTrinhLDP: dt.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoPhong).length,
            countLDPTuChoi: dt.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoPhongTuChoi).length,
            countTrinhLDPT: dt.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoPhuTrach).length,
            countLDPTTuChoi: dt.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoPhuTrachTuChoi).length,
            countTrinhLDDV: dt.filter((d: any) => d.trangThai === trangThaiKPI.trinhLanhDaoDonVi).length,
            countLDDVTuChoi: dt.filter((d: any) => d.trangThai === trangThaiKPI.lanhDaoDonViTuChoi).length,
            countPheDuyet: dt.filter((d: any) => d.trangThai === trangThaiKPI.pheDuyet).length
        };

        return (
            <div style={{ background: '#f0f4f8', padding: '0' }}>
                {/* Header */}
                {!anThongKe && < div >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}
                >
                    <BarChartOutlined
                        style={{
                            color: '#2563eb',
                            fontSize: '20px',
                            marginRight: '8px'
                        }}
                    />
                    <span
                        style={{
                            fontSize: '18px',
                            fontWeight: 700,
                            color: '#1f2937'
                        }}
                    >
                        Thống kê hiện tại
                    </span>
                </div>
                <Row gutter={[12, 12]} style={{ marginBottom: '20px' }} >

                    <Col xs={12} sm={8} lg={6} xl={6}>
                        <StatCard
                            title="Tổng số cán bộ"
                            value={tongSoCanBo}
                            subText="người"
                            description={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 6,
                                        gap: 8,
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    {/* Tham gia đánh giá */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#dcfce7',
                                            border: '1px solid #bbf7d0',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <CheckCircleFilled
                                            style={{
                                                color: '#16a34a',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#15803d',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongSoCanBoDanhGia} đánh giá
                                        </span>
                                    </div>

                                    {/* Không tham gia đánh giá */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#fee2e2',
                                            border: '1px solid #fecaca',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <CloseCircleFilled
                                            style={{
                                                color: '#dc2626',
                                                fontSize: 14
                                            }}
                                        />
                                        <Popover
                                            trigger="hover"
                                            placement="left"
                                            zIndex={10000}
                                            title={
                                                <span style={{ fontWeight: 600 }}>
                                                    Cán bộ chưa đánh giá
                                                </span>
                                            }
                                            content={
                                                <div style={{ width: 400}}>
                                                    <Table
                                                        rowKey="key"
                                                        columns={
                                                            [
                                                                {
                                                                    title: "STT",
                                                                    width: 60,
                                                                    align: "center" as const,
                                                                    render: (_: any, __: any, index: number) => index + 1
                                                                },
                                                                {
                                                                    title: "Họ tên",
                                                                    dataIndex: "hoTen"
                                                                },
                                                                {
                                                                    title: "Phòng ban",
                                                                    dataIndex: "tenDonVi"
                                                                }
                                                            ]}
                                                        dataSource={dsCanBoKhongDanhGia}
                                                        pagination={false}
                                                        size="small"
                                                        scroll={{ y: 550 }}
                                                    />
                                                </div>
                                            }
                                        >
                                            <span
                                                style={{
                                                    color: '#b91c1c',
                                                    fontWeight: 600,
                                                    fontSize: 12,
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {tongSoCanBoKhongDanhGia} không đánh giá
                                            </span>
                                        </Popover>
                                    </div>
                                </div>
                            }
                            icon={<TeamOutlined />}
                            borderColor="#3b82f6"
                            iconBg="#eff6ff"
                            iconColor="#3b82f6"
                            valueColor="#3b82f6"
                        />
                    </Col>
                    <Col xs={12} sm={8} lg={6} xl={9}>
                        <StatCard
                            title="Kết quả xếp loại"
                            value={tongSoCanBoDanhGia}
                            subText="bảng đánh giá"
                            description={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 8,
                                        gap: 8
                                    }}
                                ><div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4,
                                        background: '#fef3c7',
                                        border: '1px solid #fde68a',
                                        padding: '4px 10px',
                                        borderRadius: '999px'
                                    }}
                                >
                                        <CrownFilled
                                            style={{
                                                color: '#d97706',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#b45309',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongLoaiACong} loại A+
                                        </span>
                                    </div>
                                    {/* Loại A */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#dcfce7',
                                            border: '1px solid #bbf7d0',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <TrophyFilled
                                            style={{
                                                color: '#16a34a',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#15803d',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongLoaiA} loại A
                                        </span>
                                    </div>

                                    {/* Loại B */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#ffedd5',
                                            border: '1px solid #fdba74',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <StarFilled
                                            style={{
                                                color: '#ea580c',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#c2410c',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongLoaiB} loại B
                                        </span>
                                    </div>

                                    {/* Loại C */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#fee2e2',
                                            border: '1px solid #fecaca',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <CloseCircleFilled
                                            style={{
                                                color: '#dc2626',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#b91c1c',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongLoaiC} loại C
                                        </span>
                                    </div>
                                </div>
                            }
                            icon={<AuditOutlined />}
                            borderColor="#7c3aed"
                            iconBg="#ede9fe"
                            iconColor="#7c3aed"
                            valueColor="#7c3aed"
                        />
                    </Col>
                    <Col xs={12} sm={8} lg={6} xl={9}>
                        <StatCard
                            title="Tổng số công việc"
                            value={tongSoCongViec}
                            subText="công việc"
                            description={
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 8,
                                        gap: 8
                                    }}
                                >
                                    {/* Hoàn thành */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#dcfce7',
                                            border: '1px solid #bbf7d0',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <CheckCircleFilled
                                            style={{
                                                color: '#16a34a',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#15803d',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongHoanThanh} hoàn thành
                                        </span>
                                    </div>

                                    {/* Đang thực hiện */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#ffedd5',
                                            border: '1px solid #fdba74',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <ClockCircleFilled
                                            style={{
                                                color: '#ea580c',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#c2410c',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongDangThucHien} đang thực hiện
                                        </span>
                                    </div>

                                    {/* Không hoàn thành */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#fee2e2',
                                            border: '1px solid #fecaca',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        <CloseCircleFilled
                                            style={{
                                                color: '#dc2626',
                                                fontSize: 14
                                            }}
                                        />
                                        <span
                                            style={{
                                                color: '#b91c1c',
                                                fontWeight: 600,
                                                fontSize: 12
                                            }}
                                        >
                                            {tongKhongHoanThanh} không hoàn thành
                                        </span>
                                    </div>
                                </div>
                            }
                            icon={<FileDoneOutlined />}
                            borderColor="#2563eb"
                            iconBg="#dbeafe"
                            iconColor="#2563eb"
                            valueColor="#2563eb"
                        />
                    </Col>
                                                        </Row>
                </div>}
                <div style={{
                    background: '#fff',
                    borderRadius: '12px',
                    padding: '20px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                    <Row gutter={[16, 16]}>
                        <Col span={18}>
                            <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#1f2937', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                                TỔNG HỢP KẾT QUẢ ĐÁNH GIÁ TRONG THÁNG
                            </h4>
                        </Col>
                        <Col span={6}>
                            <Space className="float-right">
                                {
                                    // button trả về của Giám đốc
                                    traVeBtn &&
                                    <Button
                                        type="primary"
                                        icon={<CloseOutlined rev="" />}
                                        className="hrm-btn-delete float-right"
                                        onClick={() => {
                                            setConfirmModal({
                                                isShowModal: true,
                                                title: "Trả lại bảng tổng hợp KPI",
                                                content:
                                                    <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp KPI này không?</>,
                                                onSubmit: eventTraLaiTongHopKPI
                                            });
                                        }
                                        }
                                    >
                                        Trả lại
                                    </Button>
                                }
                                {
                                    // button duyệt của Giám đốc
                                    duyetToanDonViBtn &&
                                    <Button
                                        type="primary"
                                        icon={<CheckOutlined rev="" />}
                                        className="hrm-btn float-right"
                                        onClick={eventDuyetKPICaNhan}
                                    >
                                        Duyệt toàn đơn vị
                                    </Button>
                                }
                            </Space>
                        </Col>
                    </Row>
                    {
                        tongHopKPI != null && tongHopKPI?.trangThai == trangThaiKPITongHop.trinhGiamDoc && user.maChucVu == maChucVu.giamDoc && (
                            <YKienVanPhong tongHopKPI={tongHopKPI} />
                        )
                    }
                    <div style={{ overflowX: 'auto' }}>
                        <table

                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                fontSize: '13px',
                                tableLayout: 'fixed',
                                marginTop: '10px'
                            }}>
                            <thead>
                                <tr style={{ background: '#f8fafc' }}>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', width: '50px' }}>STT</th>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'left', fontWeight: 600, color: '#374151', width: '170px' }}>Phòng/Ban</th>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', width: '90px', width: '55px' }} title="Tổng số cán bộ đánh giá">Số<br />CB ĐG</th>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', width: '90px', width: '55px' }} title="Tổng số công việc">Số<br />CV</th>
                                    <th colSpan={4} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151' }}>Kết quả công việc</th>
                                    <th colSpan={4} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151' }}>Kết quả xếp loại</th>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }} title="Số lỗi vi phạm trong tháng">Lỗi VP</th>
                                    < th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', whiteSpace: 'nowrap' }}>Trạng thái</th>
                                    <th rowSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 600, color: '#374151', minWidth: '50px' }} title="Xem chi tiết">Chi tiết</th>
                                </tr>
                                <tr style={{ background: '#f8fafc' }}>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>Trước</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>Đúng</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }} title="Đang thực hiện">Đang TH</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>Trễ</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>A+</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>A</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>B</th>
                                    <th style={{ border: '1px solid #e5e7eb', padding: '8px 12px', textAlign: 'center', fontWeight: 600, color: '#374151' }}>C</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* tổng cộng */}
                                {phongBanList.length > 0 && <tr style={{ background: '#1e3a8a', color: '#fff', fontWeight: 700 }}>
                                    <td colSpan={2} style={{ border: '1px solid #e5e7eb', textAlign: 'center', fontSize: '13px' }}>TỔNG CỘNG</td>
                                    <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', width: '55px' }}>{tongCong.tongSoCanBo}</td>
                                    <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', width: '55px' }}>{tongCong.tongSoCongViec}</td>
                                    <CongViecPopover
                                        data={tongCong.dsTruoc}
                                        value={tongCong.tongTruoc}
                                        percent={tongCong.tyLeTruoc}
                                        type="excellent"
                                    />
                                    <KPIBadge
                                        showPopover={false}
                                        value={tongCong.tongDung}
                                        percent={tongCong.tyLeDung}
                                        type="success"
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsDangThucHien}
                                        value={tongCong.tongDangThucHien}
                                        percent={tongCong.tyLeDangThucHien}
                                        type="warning"
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsTre}
                                        value={tongCong.tongKhongHoanThanh}
                                        percent={tongCong.tyLeKhongHoanThanh}
                                        type="danger"
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsLoaiACong}
                                        value={tongCong.tongLoaiACong}
                                        percent={tongCong.tyLeLoaiACong}
                                        type="excellent"
                                        xepLoai
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsLoaiA}
                                        value={tongCong.tongLoaiA}
                                        percent={tongCong.tyLeLoaiA}
                                        type="success"
                                        xepLoai
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsLoaiB}
                                        value={tongCong.tongLoaiB}
                                        percent={tongCong.tyLeLoaiB}
                                        type="warning"
                                        xepLoai
                                    />
                                    <CongViecPopover
                                        data={tongCong.dsLoaiC}
                                        value={tongCong.tongLoaiC}
                                        percent={tongCong.tyLeLoaiC}
                                        type="danger"
                                        xepLoai
                                    />
                                    <ViPhamPopover
                                        data={tongCong.dsLoiViPham}
                                    />
                                    <td style={{ border: '1px solid #e5e7eb', textAlign: 'center' }}>
                                        {getTrangThaiKPIStats(tongCong)}
                                    </td>
                                    <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', width: "70" }}>
                                        <Button style={{ padding: '2px 8px', fontSize: '13px', minWidth: '50px' }}
                                            className="hrm-btn hrm-btn-sm btn-primary"
                                            onClick={() => {
                                                setOpenModalChiTiet({
                                                    isShowModal: true,
                                                    data: danhsach.data,
                                                    tenDonVi: null,
                                                    isDuyet: false
                                                });
                                            }}
                                        >
                                            Xem
                                        </Button>
                                    </td>
                                </tr>}
                                {phongBanList.length === 0 ? (
                                    <tr>
                                        <td colSpan={15} style={{ border: '1px solid #e5e7eb', padding: '20px', textAlign: 'center', color: '#9ca3af' }}>
                                            Không có dữ liệu
                                        </td>
                                    </tr>
                                ) : phongBanList.map((item: any, index: number) => (
                                    <tr key={item.idDonVi} style={{ background: index % 2 === 0 ? '#fff' : '#f9fafb' }}>
                                        <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', color: '#374151', width: '50px' }}>{index + 1}</td>
                                        <td style={{ border: '1px solid #e5e7eb', color: '#374151', fontWeight: 500, width: '170px', textAlign: "left", paddingLeft: '5px' }}>{item.tenDonVi}</td>
                                        <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', color: '#374151', width: '55px' }}>{item.tongSoCanBo}</td>
                                        <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', color: '#374151', width: '55px' }}>{item.tongSoCongViec}</td>
                                        <CongViecPopover
                                            data={item.dsTruoc}
                                            value={item.tongTruoc}
                                            type="excellent"
                                        />
                                        <KPIBadge
                                            value={item.tongDung}
                                            type="success"
                                        />
                                        <CongViecPopover
                                            data={item.dsDangThucHien}
                                            value={item.tongDangThucHien}
                                            type="warning"
                                        />
                                        <CongViecPopover
                                            data={item.dsTre}
                                            value={item.tongKhongHoanThanh}
                                            type="danger"
                                        />
                                        {/* Kết quả xếp loại */}
                                        <CongViecPopover
                                            data={item.dsAPlus}
                                            value={item.countAPlus}
                                            type="excellent"
                                            xepLoai
                                        />
                                        <CongViecPopover
                                            data={item.dsA}
                                            value={item.countA}
                                            type="success"
                                            xepLoai
                                        />
                                        <CongViecPopover
                                            data={item.dsB}
                                            value={item.countB}
                                            type="warning"
                                            xepLoai
                                        />
                                        <CongViecPopover
                                            data={item.dsC}
                                            value={item.countC}
                                            type="danger"
                                            xepLoai
                                        />
                                        <ViPhamPopover
                                            data={item.dsLoiViPham}
                                        />
                                        <td style={{ border: '1px solid #e5e7eb', textAlign: 'center', width: '90px' }}>
                                            {getTrangThaiKPIStats(item)}
                                        </td>
                                        <td style={{ border: '1px solid #e5e7eb', textAlign: 'center' }}>
                                            <Button
                                                className="hrm-btn hrm-btn-sm btn-primary" style={{ padding: '2px 8px', fontSize: '13px', minWidth: '50px' }}
                                                onClick={() => {
                                                    setOpenModalChiTiet({
                                                        isShowModal: true,
                                                        data: item.childrens,
                                                        tenDonVi: item.tenDonVi,
                                                        isDuyet: false
                                                    });
                                                }}
                                            >
                                                Xem
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {footerElements}
                    <div style={{ marginTop: '12px', fontSize: '12px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        {
                            tongHopKPI != null && showYKienVanPhong && tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet &&
                            <YKienVanPhong tongHopKPI={tongHopKPI} />
                        }
                    </div>
                </div>
            </div>
        );
    })();
};
export default TabKetQuaHoanThanh;
